import { createInjectionKey as n } from "./ghl-ui.es896.js";
const e = n("n-input");
export {
  e as inputInjectionKey
};
